const { PerWorkerEffects } = require("../Effects/Effects");
const { BuildCostOf } = require("../Moves/Costs");

// Key of a card's picture in the image context, by its name: a leader's portrait, a wonder's picture, or a technology's
// type icon (e.g. Architecture: construction); null for anything else
const PictureOf = (name) => {
    const leader = require("../Constants/Leaders/Leaders")[name];
    if (leader) return leader.image ?? null;
    if (require("../Constants/Wonders/Wonders")[name]) return require("../entities/Cards/WonderCard").ImageKey(name);
    const technology = require("../Utilities/TechnologyLookup")(name)?.GetInstance?.();
    return technology ? technology.type.replace(/\s/g, '') : null;
};

// A card on a player's board, with what the player's other cards change about it (shown on hover): what they give each
// worker on it (e.g. Darwin's +1 culture on a library), its resource cost after their discounts (e.g. Architecture),
// and which cards those are
class TechnologyViewModel {
    constructor(technology, player) {
        this.name = technology.name;
        this.contents = technology.contents;
        this.technology = technology;
        // [{ source, stat, value }]
        this.perWorker = player ? PerWorkerEffects(player, technology) : [];
        // The resource cost after their discounts, when they change it (null otherwise)
        const cost = player && technology.workerCost !== null && technology.workerCost !== undefined ? BuildCostOf(player, technology) : null;
        this.cost = cost && cost.total !== technology.workerCost ? cost.total : null;
        // The cards that change it, each once: [{ source, image }]
        const sources = [...new Set([...this.perWorker.map(effect => effect.source),
            ...(this.cost !== null ? cost.adjustments.map(adjustment => adjustment.source) : [])])];
        this.changedBy = sources.map(source => ({ source, image: PictureOf(source) }));
    }
}

module.exports = TechnologyViewModel;
